import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminSettingsApi } from '@/api/admin-settings-api'

export function useSyncSettings() {
  const queryClient = useQueryClient()

  const { data, isLoading, isError } = useQuery({
    queryKey: ['admin', 'syncSettings'],
    queryFn: adminSettingsApi.getSyncSettings,
  })

  const { mutate: updateSyncSettings, isPending } = useMutation({
    mutationFn: (settings: { 
      session_sync: {
        maryland: {
          [session: string]: boolean
        }
        federal: {
          [session: string]: boolean
        }
      }
    }) => adminSettingsApi.updateSyncSettings(settings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'syncSettings'] })
    }
  })

  return {
    data,
    isLoading,
    isError,
    updateSyncSettings,
    isPending
  }
}